export default `{
  airwallexConfig {
    enabled
    environment
    publishable_key
    supported_currencies
    supported_payment_methods {
      code
      supported_countries
      title
      type
    }
  }
}
`;
